var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSectionBlockMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 335 385",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M335 161.25V384.583H0V161.25H335ZM55 148.94H0V137.94H55V148.94ZM253.5 127.07H0V114.07H253.5V127.07ZM325 107.07H0V94.0703H325V107.07ZM292.5 87.0703H0V74.0703H292.5V87.0703ZM315 59.1904H0V44.1904H315V59.1904ZM270 38.1904H0V23.1904H270V38.1904ZM102 12H0V0H102V12Z",
  fill: "#DFDFDF"
})));
export default SvgSectionBlockMobile;